import { render, staticRenderFns } from "./HandoverDocuments.vue?vue&type=template&id=2902fabc&scoped=true"
import script from "./HandoverDocuments.vue?vue&type=script&lang=js"
export * from "./HandoverDocuments.vue?vue&type=script&lang=js"
import style0 from "./HandoverDocuments.vue?vue&type=style&index=0&id=2902fabc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2902fabc",
  null
  
)

export default component.exports